import React from 'react';
import { Phone, CheckCircle, Wrench, Shield, Car, Settings, Gauge } from 'lucide-react';
export function AutoRepairMechanicPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-956">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-957">
        <div className="container mx-auto px-4" data-id="element-958">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-959">
            Auto Repair Services
          </h1>
          <p className="text-xl text-gray-100 text-center max-w-3xl mx-auto" data-id="element-960">
            Automotive Repair Services Conveniently Located in Farmington Hills
            and Serving Farmington, Novi, Livonia, Northville Michigan Since
            1958
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-961">
        <div className="max-w-4xl mx-auto" data-id="element-962">
          {/* Main Services List */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-963">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-964">
              Our Auto Repair Services
            </h2>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-965">
              <div className="flex items-center bg-gray-50 rounded-lg p-4" data-id="element-966">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0" size={24} data-id="element-967" />
                <span className="text-lg font-semibold text-gray-800" data-id="element-968">
                  Car Repair by Certified Auto Mechanics
                </span>
              </div>

              <div className="flex items-center bg-gray-50 rounded-lg p-4" data-id="element-969">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0" size={24} data-id="element-970" />
                <span className="text-lg font-semibold text-gray-800" data-id="element-971">
                  Brake Repair and Maintenance
                </span>
              </div>

              <div className="flex items-center bg-gray-50 rounded-lg p-4" data-id="element-972">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0" size={24} data-id="element-973" />
                <span className="text-lg font-semibold text-gray-800" data-id="element-974">
                  Ignition Repair
                </span>
              </div>

              <div className="flex items-center bg-gray-50 rounded-lg p-4" data-id="element-975">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0" size={24} data-id="element-976" />
                <span className="text-lg font-semibold text-gray-800" data-id="element-977">
                  Power Steering Repair
                </span>
              </div>

              <div className="flex items-center bg-gray-50 rounded-lg p-4" data-id="element-978">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0" size={24} data-id="element-979" />
                <span className="text-lg font-semibold text-gray-800" data-id="element-980">
                  Engine Repair
                </span>
              </div>

              <div className="flex items-center bg-gray-50 rounded-lg p-4" data-id="element-981">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0" size={24} data-id="element-982" />
                <span className="text-lg font-semibold text-gray-800" data-id="element-983">
                  Transmission Repair and Maintenance
                </span>
              </div>

              <div className="flex items-center bg-gray-50 rounded-lg p-4" data-id="element-984">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0" size={24} data-id="element-985" />
                <span className="text-lg font-semibold text-gray-800" data-id="element-986">
                  Drivetrain Repair and Maintenance
                </span>
              </div>

              <div className="flex items-center bg-gray-50 rounded-lg p-4" data-id="element-987">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0" size={24} data-id="element-988" />
                <span className="text-lg font-semibold text-gray-800" data-id="element-989">
                  Automotive Maintenance
                </span>
              </div>
            </div>
          </div>

          {/* Car Repair by Certified Mechanics */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-990">
            <div className="flex items-center mb-4" data-id="element-991">
              <div className="bg-blue-100 rounded-lg p-3 mr-4" data-id="element-992">
                <Shield className="text-blue-600" size={28} data-id="element-993" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-994">
                Car Repair By Certified Mechanics
              </h2>
            </div>
            <p className="text-gray-700 leading-relaxed" data-id="element-995">
              Car repair by certified auto mechanics means you can trust our
              mechanics to diagnose, estimate and repair your car or truck
              properly. We've built an excellent reputation in our community for
              the quality of service our repair shop provides. Our customers
              come from all over the region because they trust our repair
              facility and mechanics. We've been repairing cars at our
              Farmington Hills, Michigan auto repair shop since 1958.
            </p>
          </div>

          {/* Brake Repair */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-996">
            <div className="flex items-center mb-4" data-id="element-997">
              <div className="bg-red-100 rounded-lg p-3 mr-4" data-id="element-998">
                <Settings className="text-red-600" size={28} data-id="element-999" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-1000">
                Brake Repair and Maintenance
              </h2>
            </div>
            <p className="text-gray-700 leading-relaxed" data-id="element-1001">
              Your car's brakes are an important safety feature of your car. The
              brakes should be inspected two times a year to help catch any
              problems before doing severe damage. More about{' '}
              <a href="/auto-repair/brake-repair" className="text-[#B1050B] hover:underline font-semibold" data-id="element-1002">
                brake repair
              </a>{' '}
              services.
            </p>
          </div>

          {/* Ignition Repair */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-1003">
            <div className="flex items-center mb-4" data-id="element-1004">
              <div className="bg-yellow-100 rounded-lg p-3 mr-4" data-id="element-1005">
                <Gauge className="text-yellow-600" size={28} data-id="element-1006" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-1007">
                Ignition Repair, Diagnosis and Maintenance
              </h2>
            </div>
            <p className="text-gray-700 leading-relaxed" data-id="element-1008">
              Ignition systems are more complex than ever. If your car's
              ignition isn't functioning properly, it's a good idea to bring it
              in for diagnosis as soon as possible.
            </p>
          </div>

          {/* Brake Safety Highlight */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-1009">
            <div className="flex flex-col md:flex-row items-center" data-id="element-1010">
              <div className="flex-shrink-0 mb-6 md:mb-0 md:mr-8" data-id="element-1011">
                <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauto%20truck%20suppliers%2FNew%20Folder%2Fstop.bmp&site=1986&w=223&h=236&user=1617&opt=w3" alt="Brake Safety - Stop Sign" className="w-48 h-auto rounded-lg" data-id="element-1012" />
              </div>
              <div className="text-center md:text-left" data-id="element-1013">
                <h3 className="text-2xl font-bold mb-2" data-id="element-1014">
                  Auto Brake Repair - Auto Ignition Repair - Auto Engine Repair
                </h3>
                <p className="text-xl font-semibold mb-2" data-id="element-1015">
                  Brakes are the most important safety device on your car
                </p>
                <p className="text-gray-100" data-id="element-1016">
                  You should have the brakes on your car inspected twice a year.
                </p>
              </div>
            </div>
          </div>

          {/* Certified Auto Repair Mechanics - Complete Services */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-1017">
            <div className="flex items-center mb-4" data-id="element-1018">
              <div className="bg-green-100 rounded-lg p-3 mr-4" data-id="element-1019">
                <Wrench className="text-green-600" size={28} data-id="element-1020" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-1021">
                Auto Repair - Certified Auto Repair Mechanics
              </h2>
            </div>
            <p className="text-gray-700 leading-relaxed mb-6" data-id="element-1022">
              Auto repair services covering the complete range of systems and
              components. Major auto repairs include engines, transmissions,
              drivelines, differentials, and transfer clutches. Complete brake
              inspection, diagnosis, maintenance, and repair. Our certified
              brake mechanics maintain and repair all types and sizes of brake
              systems.
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-1023">
              <div className="flex items-center" data-id="element-1024">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1025" />
                <span className="text-gray-700" data-id="element-1026">Auto Engine Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1027">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1028" />
                <span className="text-gray-700" data-id="element-1029">
                  Automatic Transmission Repair
                </span>
              </div>
              <div className="flex items-center" data-id="element-1030">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1031" />
                <span className="text-gray-700" data-id="element-1032">
                  Manual Transmission Repair
                </span>
              </div>
              <div className="flex items-center" data-id="element-1033">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1034" />
                <span className="text-gray-700" data-id="element-1035">
                  Clutch Inspection and Replacement
                </span>
              </div>
              <div className="flex items-center" data-id="element-1036">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1037" />
                <span className="text-gray-700" data-id="element-1038">Transfer Case Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1039">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1040" />
                <span className="text-gray-700" data-id="element-1041">Transaxle Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1042">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1043" />
                <span className="text-gray-700" data-id="element-1044">Brake System Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1045">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1046" />
                <span className="text-gray-700" data-id="element-1047">U-Joint Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1048">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1049" />
                <span className="text-gray-700" data-id="element-1050">Driveshaft Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1051">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1052" />
                <span className="text-gray-700" data-id="element-1053">Halfshaft Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1054">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1055" />
                <span className="text-gray-700" data-id="element-1056">Steering Column Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1057">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1058" />
                <span className="text-gray-700" data-id="element-1059">Steering System Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1060">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1061" />
                <span className="text-gray-700" data-id="element-1062">Differential Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1063">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1064" />
                <span className="text-gray-700" data-id="element-1065">Rear Axle Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1066">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1067" />
                <span className="text-gray-700" data-id="element-1068">Front Wheel Drive Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1069">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1070" />
                <span className="text-gray-700" data-id="element-1071">Four Wheel Drive Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1072">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1073" />
                <span className="text-gray-700" data-id="element-1074">All Wheel Drive Repair</span>
              </div>
              <div className="flex items-center" data-id="element-1075">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-1076" />
                <span className="text-gray-700" data-id="element-1077">Suspension System Repair</span>
              </div>
            </div>
          </div>

          {/* Service Area Links */}
          <div className="bg-white rounded-lg shadow-md p-6 mb-8" data-id="element-1078">
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-1079">
              Serving These Communities
            </h3>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-1080">
              <span className="bg-gray-100 px-4 py-2 rounded-lg text-gray-700 font-medium" data-id="element-1081">
                Novi Auto Repair
              </span>
              <span className="bg-gray-100 px-4 py-2 rounded-lg text-gray-700 font-medium" data-id="element-1082">
                Farmington Auto Repair
              </span>
              <span className="bg-gray-100 px-4 py-2 rounded-lg text-gray-700 font-medium" data-id="element-1083">
                Livonia Auto Repair
              </span>
              <span className="bg-gray-100 px-4 py-2 rounded-lg text-gray-700 font-medium" data-id="element-1084">
                Northville Auto Repair
              </span>
              <span className="bg-gray-100 px-4 py-2 rounded-lg text-gray-700 font-medium" data-id="element-1085">
                Farmington Hills Auto Repair
              </span>
            </div>
          </div>

          {/* Shop Image */}
          <div className="bg-white rounded-lg shadow-md p-4 mb-8" data-id="element-1086">
            <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/GarrettAutoRepairTruckRepair.jpg?opt=w3" alt="Garrett Auto Repair - Farmington Hills Michigan" className="w-full h-auto rounded-lg" data-id="element-1087" />
            <p className="text-center text-gray-600 mt-4 font-medium" data-id="element-1088">
              Garrett Auto & Truck Service - Farmington Hills, Michigan
            </p>
          </div>

          {/* Why Choose Us */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-1089">
            <h2 className="text-3xl font-bold mb-6 text-center" data-id="element-1090">
              Why Choose Garrett Auto & Truck?
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-1091">
              <div className="text-center" data-id="element-1092">
                <div className="bg-white/20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-1093">
                  <Shield className="text-white" size={32} data-id="element-1094" />
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-1095">Certified Mechanics</h3>
                <p className="text-blue-100" data-id="element-1096">
                  Experienced, trained professionals you can trust
                </p>
              </div>

              <div className="text-center" data-id="element-1097">
                <div className="bg-white/20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-1098">
                  <Wrench className="text-white" size={32} data-id="element-1099" />
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-1100">Quality Service</h3>
                <p className="text-blue-100" data-id="element-1101">
                  Excellent reputation built since 1958
                </p>
              </div>

              <div className="text-center" data-id="element-1102">
                <div className="bg-white/20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-1103">
                  <Car className="text-white" size={32} data-id="element-1104" />
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-1105">All Makes & Models</h3>
                <p className="text-blue-100" data-id="element-1106">
                  Cars, trucks, SUVs - we service them all
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-1107">
            <h2 className="text-3xl font-bold mb-4" data-id="element-1108">
              Need Auto Repair Services?
            </h2>
            <p className="text-xl mb-6" data-id="element-1109">
              Trust our certified mechanics for all your automotive repair and
              maintenance needs
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-1110">
              <Phone className="mr-3" size={24} data-id="element-1111" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-1112">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
            <p className="mt-2 text-gray-400 text-sm" data-id="element-1113">
              Serving the community since 1958
            </p>
          </div>
        </div>
      </div>
    </div>;
}